import { useEffect, useState } from 'react';
import { AiEntryChat } from './AiEntryChat';

/**
 * A floating "smart entry" launcher pinned to every screen. It opens a slide-over
 * that renders the SAME <AiEntryChat/> engine used by the full «ثبت هوشمند» tab —
 * so a new customer / supplier / FX rate can be dictated (or a photographed card /
 * invoice OCR'd) from wherever you already are, without leaving the page you're on.
 *
 * The chat mounts only while the panel is open, so there's never a second instance
 * (config poll, spend meter) running behind the closed dock, and none of it clashes
 * with the dedicated tab.
 */
export function SmartEntryDock() {
  const [open, setOpen] = useState(false);

  // Esc closes the panel — expected for any slide-over / dialog.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        className="smart-fab"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-label="ثبت هوشمند با دستیار"
        title="ثبت هوشمند با دستیار"
      >
        {open ? '✕' : '✨'}
      </button>
      {open ? (
        <>
          <div className="smart-scrim" onClick={() => setOpen(false)} />
          <aside className="smart-dock" role="dialog" aria-label="ثبت هوشمند با دستیار">
            <AiEntryChat />
          </aside>
        </>
      ) : null}
    </>
  );
}
